import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { PARTNER_ADDED_FROM } from '../../utils/partnerAddedFrom';
import { formatPartnerSubscriptionFeeLabel } from '../../utils/partnerAcceptPlans';

/**
 * Single column: configured fee, active entitlement, and edit-amount for website partners.
 */
const PartnerSubscriptionCell = ({ partner, onEditAmount, editDisabled = false }) => {
  const isWebsitePartner = partner?.addedFrom === PARTNER_ADDED_FROM.WEBSITE;
  const feeLabel = formatPartnerSubscriptionFeeLabel(partner?.subscriptionPlan);
  const currentPlan = partner?.currentPlan ?? null;
  const expiresLabel = currentPlan?.expiresAtLabel || null;
  const hasActiveSubscription = Boolean(currentPlan);

  if (!isWebsitePartner) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 1,
        minWidth: 168,
      }}
    >
      <Box sx={{ minWidth: 0, display: 'flex', flexDirection: 'column', gap: 0.35 }}>
        <Typography variant="body2" sx={{ fontWeight: 700, lineHeight: 1.35 }}>
          {feeLabel || 'Fee not set'}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: hasActiveSubscription ? 'success.dark' : 'text.secondary',
            fontWeight: 600,
            lineHeight: 1.35,
          }}
        >
          {hasActiveSubscription
            ? expiresLabel
              ? `Active · until ${expiresLabel}`
              : 'Active subscription'
            : 'No active subscription'}
        </Typography>
      </Box>

      <Tooltip title="Update portal fee">
        <span>
          <IconButton
            aria-label={`Update portal fee for ${partner?.fullName || 'partner'}`}
            onClick={() => onEditAmount?.(partner)}
            disabled={editDisabled}
            size="small"
            sx={{ color: 'primary.main', mt: -0.25 }}
          >
            <EditOutlinedIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default PartnerSubscriptionCell;
